module.exports = __webpack_public_path__ + "img/良好口碑.06b9ae87.jpg";